import { getIsDesktopLayout } from '@shared/selectors';
import * as actions from '../actionTypes';

const updateIsDesktopLayout = isDesktop => (dispatch, getState) => {
  const type = actions.UPDATE_IS_DESKTOP_LAYOUT;
  const state = getState();
  const current = getIsDesktopLayout(state);

  if (current !== isDesktop) {
    dispatch({ type, payload: isDesktop });
  }
};

export default updateIsDesktopLayout;
